module.exports = __webpack_public_path__ + "img/staszewski.046fcd93.jpg";